'use client';

import { useQuery } from '@tanstack/react-query';
import { newsService } from '../services/newsService';
import type { IPagination } from '../types/common';

export const useTrendingNews = (category?: string, params?: IPagination) => {
	return useQuery({
		queryKey: ['news', 'trending', category, params],
		queryFn: () => newsService.getTrendingNews(category, params),
	});
};
